import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { format } from "date-fns"

const now = new Date(Date.now())
const init_date = {
  month: format(new Date(now.getFullYear(), now.getMonth(), now.getDate()), "yyyy/MM/dd"),
  comparison_month: format(new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()), "yyyy/MM/dd"),
}

const initialState: Metricate.IntialDate = init_date

const dateSlice = createSlice({
  name: "date",
  initialState,
  reducers: {
    updateDates: (state, action: PayloadAction<Date>) => {
      const comparison_month = new Date(action.payload)
      comparison_month.setMonth(comparison_month.getMonth() - 1)
      state.month = format(action.payload, "yyyy/MM/dd")
      state.comparison_month = format(comparison_month, "yyyy/MM/dd")
    },
  },
})

export const { updateDates } = dateSlice.actions
export default dateSlice.reducer
